(function() {
    'use strict';
  
    angular
      .module('iqxCore')
      .config($compileProviderConfig)

  
    function $compileProviderConfig($compileProvider){
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto):/)
    }
  
})()